
// import { honorList, gethonorInfo } from '../config/apiUrl'
import API from '../services';
const { getHonorList, getHonorDeatail } = API.dataqin

const getHonorListData = async (params, _isBrowser) => {
    return new Promise(resolve => {
        honorList(params, _isBrowser).then((result) => {
            resolve({
                record: result.records
            })
       })
    })
}

const getHonorData = async (params) => {
    const { id } = params.payload
    return new Promise(resolve => {
        gethonorInfo(id).then((result) => {
            resolve({
                record: result
            })
       
        })
    })
}

export default {
    namespace: 'honor',
    state: {
        honorlist: [],
        honorInfo: {},
        currentPage: 1,
        noMore: false
    },
    reducers: {
        initHonor(state, { payload , pageNum}) {
            let _state = state
            if(payload && payload.length === 0) {
                // 暂无最新数据
                _state.noMore = true
            }
            if(pageNum > 1 && state.currentPage !== pageNum) {
                return {
                    ..._state,
                    currentPage: pageNum,
                    honorlist: state.honorlist.concat(payload)
                }
            }
            
            return {
              ..._state,
              honorlist: payload
            }

        },
        honorinfo(state, { payload }) {
            return {
                ...state,
                honorInfo: payload
              }
        }
    },
    effects: {
        *setHonor({ payload }, {put}) {
            yield put({
                type: 'initHonor',
                payload: payload.record,
                pageNum: 1
            })
        },
        // 获取论文列表
        *getHonorList({ payload, _isBrowser }, { call, put }) {
            const result = yield call(getHonorList, payload, _isBrowser)
            const { pageNum } = payload
            // 成功
            yield put({
                type: 'initHonor',
                payload: result.records,
                pageNum
            })
        },
        // 获取详情
        *getHonorInfo({ payload, _isBrowser }, { call, put }) {
            const result = yield call(getHonorDeatail, { ...payload })
            // 成功
            yield put({
                type: 'honorinfo',
                payload: result
            })
        },
    }
}